<template>
  <or-layout>
    <h3 class="page">
      班级信息
      <a-button type="primary" icon="left" @click="goPage">返回</a-button>
    </h3>

    <div class="main">
      <a-row class="row" :gutter="16">
        <a-col :span="16">
          <h2 class="title">{{ squad_info.campusname }} {{ squad_info.gradename }}
            {{ squad_info.squadname }}</h2>
          <div class="row">班主任:{{ squad_info.instructor }} / 老师:{{ squad_info.teacher }}</div>
        </a-col>
        <a-col :span="2">
          <a-statistic title="学生" :value="squad_info.studentcount" />
        </a-col>
        <a-col :span="2">
          <a-statistic title="任务" :value="squad_info.missioncount" />
        </a-col>
        <a-col :span="2">
          <a-statistic title="参测率" :value="squad_info.cancelv">
            <template #suffix>
              <span>%</span>
            </template>
          </a-statistic>
        </a-col>
        <a-col :span="2">
          <a-statistic title="正确率" :value="squad_info.zhengquelv">
            <template #suffix>
              <span>%</span>
            </template>
          </a-statistic>
        </a-col>
      </a-row>
      <a-tabs class="row" type="card" @change="tabsChange">
        <a-tab-pane tab="学生" key="stuent">
          <a-table :dataSource="squadStudentList" :rowKey="item => item.id" :pagination="pageinfo"
            @change="onPaginationChange" bordered>
            <a-table-column key="nickname" title="学生名字" data-index="nickname" />
            <a-table-column key="mobile" title="联系电话" data-index="mobile" />
            <a-table-column key="is_special" title="是否参与统计">
              <template slot-scope="item">
                <a-tag color="orange" v-if="item.is_special === 0">
                  参与
                </a-tag>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>{{ item.cause }}</span>
                  </template>
                  <a-tag color="green" v-if="item.is_special === 1">
                    不参与
                  </a-tag>
                </a-tooltip>
              </template>
            </a-table-column>
            <a-table-column key="jion_time" title="进班时间">
              <template slot-scope="item">
                {{ moment(item.jion_time * 1000).format('lll') }}
              </template>
            </a-table-column>


            <a-table-column key="active" width="240px" title="操作">
              <template slot-scope="item">
                <a-button @click="removeGradeStudent(item)" class="active_btn" size="small" type="link">移出班级
                </a-button>
                <a-button @click="settongjistudent(item)" class="active_btn" size="small" type="link">设置
                </a-button>
                <a-button :loading="loading" type="primary" @click="show_edit_nickname(item)" class="active_btn"
                  size="small">改名
                </a-button>
              </template>
            </a-table-column>
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="任务" key="tasks">
          <a-table :dataSource="squadMissionList" :rowKey="item => 'tasks' + item.start_time + item.end_time + item.mission_id"
            :pagination="pageinfo" @change="onTaskPaginationChange" bordered>
            <a-table-column key="missionname" title="任务名字" data-index="missionname" />
            <a-table-column key="misstypename" width="100px" title="任务类型" data-index="misstypename" />
            <a-table-column key="kcnmission" title="任务来源" data-index="kcnmission">
              <template slot-scope="text, item">
                <a-tag style="background-color:firebrick;color:white" v-if="item.kcnmission == 0">
                  自主任务
                </a-tag>
                <a-tag style="background-color:skyblue;color:white" v-if="item.kcnmission == 1">
                  课程包任务
                </a-tag>
              </template>
            </a-table-column>

            <a-table-column key="start_time" title="时间" data-index="start_time">
              <template slot-scope="text, item">
                <range-picker :start-time="item.start_time" :end-time="item.end_time"
                  @change="editMissionTime(item, $event)" />
              </template>

            </a-table-column>
            <a-table-column key="active" width="320px" title="操作">
              <template slot-scope="item">
                <!--   <a-button @click="tableDel({squad_id:item.squad_id,mission_id:item.mission_id})"
                                          class="active_btn" size="small" type="link">删除
                                </a-button> -->
                <view-exam-modal
                  :item="{ id: item.examination_id, typename: item.testpapertypename, semestername: item.semestername, gradename: item.gradename, name: item.testpapername }" />
                <!--  <router-link
                                        :to="{path:'/missionsimilarinfo',query:{squad_id:item.squad_id,mission_id:item.mission_id}}">
                                    相似题
                                </router-link> -->
                <!--  <show-grade-mission-student :item="item"/> -->
              </template>
            </a-table-column>
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="课程安排" key="course">
          <a-table :dataSource="squadChapterList" :rowKey="item => item.id" :pagination="false" bordered>
            <a-table-column key="name" title="章节名字" data-index="name" />
            <a-table-column key="start_time" title="时间" data-index="start_time">
              <template slot-scope="text, item">
                <div>
                  <range-picker :start-time="item.start_time" :end-time="item.end_time"
                    @change="editChapterTime(item, $event)" />
                </div>
              </template>
            </a-table-column>
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="随堂测试" key="stcs">
          <a-table :dataSource="squadMissionList" :rowKey="item => item.start_time + item.end_time" :pagination="false"
            bordered>
            <a-table-column key="missionname" title="任务名字" data-index="missionname" />
            <a-table-column key="kcnmission" title="任务来源" data-index="kcnmission">
              <template slot-scope="text, item">
                <a-tag style="background-color:firebrick;color:white" v-if="item.kcnmission == 0">
                  自主任务
                </a-tag>
                <a-tag style="background-color:skyblue;color:white" v-if="item.kcnmission == 1">
                  课程包任务
                </a-tag>
              </template>
            </a-table-column>

            <a-table-column key="start_time" title="时间" data-index="start_time">
              <template slot-scope="text, item">
                <range-picker :start-time="item.start_time" :end-time="item.end_time"
                  @change="editMissionTime(item, $event)" />
              </template>
            </a-table-column>
            <a-table-column key="active" width="180px" title="操作">
              <template slot-scope="item">
                <a-button @click="tableDel({ squad_id: item.squad_id, mission_id: item.mission_id })" class="active_btn"
                  size="small" type="link">删除任务
                </a-button>
              </template>
            </a-table-column>
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="每日一练" key="mryl">
          <a-table :dataSource="squadMissionList" :rowKey="item => item.start_time + item.end_time" :pagination="false"
            bordered>
            <a-table-column key="missionname" title="任务名字" data-index="missionname" />
            <a-table-column key="kcnmission" title="任务来源" data-index="kcnmission">
              <template slot-scope="text, item">
                <a-tag style="background-color:firebrick;color:white" v-if="item.kcnmission == 0">
                  自主任务
                </a-tag>
                <a-tag style="background-color:skyblue;color:white" v-if="item.kcnmission == 1">
                  课程包任务
                </a-tag>
              </template>
            </a-table-column>

            <a-table-column key="start_time" title="时间" data-index="start_time">
              <template slot-scope="text, item">
                <range-picker :start-time="item.start_time" :end-time="item.end_time"
                  @change="editMissionTime(item, $event)" />
              </template>

            </a-table-column>
            <a-table-column key="active" width="180px" title="操作">
              <template slot-scope="item">
                <a-button @click="tableDel({ squad_id: item.squad_id, mission_id: item.mission_id })" class="active_btn"
                  size="small" type="link">删除任务
                </a-button>
              </template>
            </a-table-column>
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="学习报告" key="report">
          <a-table />
        </a-tab-pane>
        <a-tab-pane tab="设置" key="settings">
          <!--   <a-button :loading="loading" @click="makeGradeMiss" type="primary">生成任务</a-button> -->
          <a-button :loading="loading" style="margin-left: 5px;" @click="getSquadStudentListAll" type="primary">批量转班
          </a-button>
        </a-tab-pane>
      </a-tabs>
    </div>

    <a-modal title="设置不参与统计学生" :visible="visible" :confirm-loading="loading" @ok="handleOk" @cancel="handleCancel">
      <a-form layout="inline">
        <a-form-item>
          <a-textarea v-model="cause" placeholder="不参与统计的原因" style="width: 100%;" :auto-size="{ minRows: 5, maxRows: 8 }" />
          <a-radio-group v-model="is_special" button-style="solid">
            <a-radio-button :value="1">
              不参与
            </a-radio-button>
            <a-radio-button :value="0">
              正常
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="批量加班" :visible="student_to_squad_visible" :confirm-loading="loading" @ok="student_to_squad"
      @cancel="student_to_squad_visible = false">
      <a-form layout="inline">
        <a-input v-model="squadcode" placeholder="班级码" />
        <a-checkbox-group name="user_ids" @change="onGroupChange">
          <a-table :dataSource="squadStudentListAll" :rowKey="item => 'st_' + item.id" :pagination="false">
            <a-table-column key="nickname" title="学生名字">
              <template slot-scope="item">
                <a-checkbox :value="item.id">{{ item.nickname }}</a-checkbox>
              </template>
            </a-table-column>
            <a-table-column key="mobile" title="联系电话" data-index="mobile" />
          </a-table>
        </a-checkbox-group>

      </a-form>
    </a-modal>
    <a-modal :confirm-loading="loading" :width="240" title="修改学生名字" :visible="edit_nickname_visible"
      @ok="submit_edit_nickname" @cancel="edit_nickname_visible = false">
      <a-form layout="inline">
        <a-form-item>
          <a-input v-model="edit_nickname_form.nickname" placeholder="学生名字" />
        </a-form-item>
      </a-form>
    </a-modal>
  </or-layout>
</template>


<script>
import RangePicker from "@/components/range-picker";
import moment from "moment";
import ViewExamModal from '@/components/question/view-exam-modal.vue'
// import ShowGradeMissionStudent from "@/components/show_grade_mission_student";


export default {
  components: {
    "range-picker": RangePicker,
    ViewExamModal
    // ,ShowGradeMissionStudent
  },
  data() {
    return {
      pageinfo: {
        total: 1,
        current: 1,
        pageSize: 10
      },
      loading: false,
      squad_id: "",
      squadChapterList: [],
      squad_info: {},
      squadStudentList: [],
      squadStudentListAll: [],
      squadMissionList: [],
      mission_type: "",
      visible: false,
      tongjistudent_id: '',
      is_special: '',
      cause: '',
      student_to_squad_visible: false,
      edit_nickname_visible: false,
      edit_nickname_form: {
        id: undefined,
        nickname: undefined
      },
      squadcode: undefined,
      user_ids: undefined
    }
  },
  mounted() {
    this.squad_id = this.$route.query.id;
    this.getSquadInfo(this.squad_id);
    this.getSquadStudentList(this.squad_id);
  },

  methods: {
    student_to_squad() {
      if (!this.squadcode) {
        this.$error({
          title: "错误",
          content: "请输入班级码",
          okText: "确定"
        });
        return;
      }
      if (!this.user_ids || this.user_ids == "") {
        this.$error({
          title: "错误",
          content: "请选择需要转班的学生",
          okText: "确定"
        });
        return;
      }
      this.loading = true;
      this.$axios
        .post("/api/OrgSquad/add_student_to_squad", {
          data: { squadcode: this.squadcode, user_ids: this.user_ids }
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.$success({
              title: "成功",
              content: "处理完成，请去新班级查看学生信息",
              okText: "确定"
            });
            this.student_to_squad_visible = false;
          }
        })
        .catch(err => {
          console.error(err);
        });

    },
    onGroupChange(user_ids) {
      this.user_ids = user_ids.join(',');
    },
    show_edit_nickname(item) {
      this.edit_nickname_form.id = item.id;
      this.edit_nickname_form.nickname = item.nickname;
      this.edit_nickname_visible = true;
    },
    submit_edit_nickname() {
      this.loading = true;
      let _this = this;
      this.$axios
        .post("/api/user/change_user_nickname", {
          data: _this.edit_nickname_form
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.edit_nickname_visible = false;
            this.getSquadStudentList(_this.squad_id);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSquadMissList() {
      this.$axios
        .post("/api/OrgSquad/getsquadmissionlist", {
          data: {
            squad_id: this.squad_id,
            mission_type: this.mission_type
          },
          pageinfo: this.pageinfo
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.squadMissionList = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },


    /*  makeGradeMiss() {
        this.$axios
          .post("/api/OrgSquad/setsquadmission", {
            data: {
              squad_id: this.squad_id
            }
          })
          .then(res => {
            if (res.code != 200) {
              this.$error({
                title: "错误",
                content: res.msg,
                okText: "确定"
              });
            } else {
              this.$success({
                title: "正确",
                content: "任务生成完成",
                okText: "确定"
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      }, */
    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.getSquadStudentList(this.squad_id);
    },
    onTaskPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.getSquadMissList();
    },
    tabsChange(key) {
      this.pageinfo.current = 1;
      switch (key) {
        case "stuent":
          this.getSquadStudentList(this.squad_id);
          break;
        case "tasks":
          this.mission_type = "";
          this.getSquadMissList();
          break;
        case "course":
          this.getSquadChapter(this.squad_id);
          break;
        case "stcs":
          this.mission_type = "stcs";
          this.getSquadMissList();
          break;
        case "mryl":
          this.mission_type = "mryl";
          this.getSquadMissList();
          break;

        default:
          break;
      }
    },
    //把学生从指定班级移出
    removeGradeStudent(item) {
      let _this = this;
      this.$confirm({
        title: "移除用户",
        content: "确认移除学生：" + item.nickname + "?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/User/delorg", {
              data: {
                user_id: item.id,
                squad_id: _this.squad_id
              }
            })
            .then(res => {
              if (res.code != 200) {
                this.$error({
                  title: "错误",
                  content: res.msg,
                  okText: "确定"
                });
              } else {
                _this.getSquadStudentList(_this.squad_id);
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });

    },

    settongjistudent(item) {
      this.tongjistudent_id = item.id;
      this.is_special = item.is_special;
      this.cause = item.cause;
      this.visible = true;

    },
    handleCancel() {
      this.tongjistudent_id = '';
      this.visible = false;
    },

    //提交不参与统计的学生信息
    handleOk() {
      this.$axios
        .post("/api/User/set_special_user", {
          data: {
            user_id: this.tongjistudent_id,
            squad_id: this.squad_id,
            is_special: this.is_special,
            cause: this.cause,
          }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.visible = false;
            this.getSquadStudentList(this.squad_id);
          }
        })
        .catch(err => {
          console.error(err);
        });

    },
    //获取班级信息
    getSquadInfo(id) {
      this.$axios
        .post("/api/OrgSquad/getsquadinfo", {
          data: {
            id: id
          }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.squad_info = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    goPage() {
      this.$router.push('/orgsquad');
    },
    //获取班级的学生列表
    getSquadStudentList(id) {
      this.$axios
        .post("/api/User/getsquaduserlist", {
          data: {
            squad_id: id
          },
          pageinfo: this.pageinfo
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.squadStudentList = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    //获取班级的学生列表
    getSquadStudentListAll() {
      this.loading = true;
      this.$axios
        .post("/api/User/getsquaduserlist", {
          data: {
            squad_id: this.squad_id
          },
          pageinfo: {
            current: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.squadStudentListAll = res.data.data;
            this.student_to_squad_visible = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    //任务相关方法
    getSquadChapter(id) {
      this.$axios
        .post("/api/OrgSquad/getchapter", {
          data: {
            squad_id: id
          }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.squadChapterList = res.data;

          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    editChapterTime(item, range) {
      let data = {
        chapter_id: item.id,
        squad_id: item.squad_id,
        start_time: parseInt(range[0].valueOf() / 1000),
        end_time: parseInt(range[1].valueOf() / 1000)
      };
      this.$axios
        .post("/api/OrgSquad/setchaptertime", {
          data
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getSquadChapter(this.squad_id);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    editMissionTime(item, range) {
      let data = {
        mission_id: item.mission_id,
        squad_id: item.squad_id,
        start_time: parseInt(range[0].valueOf() / 1000),
        end_time: parseInt(range[1].valueOf() / 1000)
      };
      this.$axios
        .post("/api/OrgSquad/editsquadmission", {
          data
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getSquadMissList(data.squad_id);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    tableDel(data) {
      let _this = this;
      _this.$confirm({
        title: "删除任务",
        content: "确认删除当前任务吗?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/OrgSquad/delsquadmission", {
              data
            })
            .then(res => {
              if (res.code != 200) {
                _this.$error({
                  title: "错误",
                  content: res.msg,
                  okText: "确定"
                });
              } else {
                _this.getSquadMissList();
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    moment
  }
};
</script>


<style lang="less" scoped>
.main {
  margin-top: 1.5rem;
}

.row {
  margin-top: 1rem;
}

.title {
  font-weight: 700;
  font-family: 微软雅黑, tahoma;
}

.page {
  display: flex;
  justify-content: space-between;
}
</style>
